<template>
  <Drawer v-model:open="open">
    <DrawerTrigger>
      <Button variant="outline">
        <SvgIcon name="toggle-menu" class="fill-black" />
      </Button>
    </DrawerTrigger>
    <DrawerContent>
      <DrawerHeader>
        <DrawerTitle>目录</DrawerTitle>
        <DrawerDescription>你想访问什么功能？</DrawerDescription>
      </DrawerHeader>
      <div class="overflow-auto p-6">
        <template v-for="route in routes" :key="route.path">
          <div class="flex flex-col space-y-3" v-if="route.children?.length == 0">
            <LinkItem :to="route.path" @click="open = false">{{ route.meta?.title }}</LinkItem>
          </div>
          <div class="flex flex-col space-y-2" v-else>
            <div class="flex flex-col space-y-3 pt-6 pb-3">
              <h4 class="font-medium">{{ route.meta?.title }}</h4>
              <div class="flex flex-col space-y-2">
                <LinkItem
                  v-for="item in route.children"
                  :key="item.path"
                  :to="item.path"
                  class="text-muted-foreground"
                  @click="open = false"
                >
                  {{ item.meta?.title }}
                  <span
                    class="ml-2 rounded-md bg-[#E8F6FB] text-primary px-1.5 py-0.5 text-xs leading-none no-underline group-hover:no-underline"
                    :class="[item.meta?.tag == 'dev' ? 'bg-[#FFF2CC] text-[#FF8C00]!' : '']"
                    >{{ item.meta?.tag }}</span
                  >
                </LinkItem>
              </div>
            </div>
          </div>
        </template>
      </div>
    </DrawerContent>
  </Drawer>
</template>
<script setup lang="ts">
import { Drawer, DrawerContent, DrawerDescription, DrawerHeader, DrawerTitle, DrawerTrigger } from '~/components/ui/drawer';
import { Button } from '~/components/ui/button';
const routes = nestRoutes();
const open = ref(false);
</script>
